import { createContext, useContext } from 'react';

export const SuperAdminContext = createContext(null);

export const useSuperAdminContext = () => {
  const ctx = useContext(SuperAdminContext);
  if (!ctx) {
    throw new Error('useSuperAdminContext must be used within SuperAdminContext.Provider');
  }
  return ctx;
};
